import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-6 mt-8 rounded-t-2xl shadow-inner">
      <div className="container mx-auto text-center">
        <p className="text-sm">&copy; 2025 Mây Xanh. Mọi quyền được bảo lưu.</p>
        <p className="text-sm mt-2">Được thiết kế với ❤️ dành cho học sinh Việt Nam.</p>
      </div>
    </footer>
  );
};

export default Footer;
